import { parseDate, toDate, parseDateTime } from './DateHelper';

export const getEdicao = contexts => contexts.edicao;

export const getEdicaoAnterior = contexts => contexts.edicaoAnterior;

export const getFullEdition = contexts => `${getEdicao(contexts)}ª Olimpíada Mirim - OBMEP ${getAno(contexts)}`;

export const getAno = contexts => contexts.ano;

export const getPeriodoDePagamentoFormatado = contexts => contexts.periodoDePagamentoFormatado;

export const getDataFimDePagamentoFormatado = contexts => contexts.dataFimDePagamentoFormatado;

export const getDataFimPeriodoDeInscricaoFormatado = contexts => contexts.dataFimPeriodoDeInscricaoFormatado;

export const getDataFimResolverProblemasEmpatesPremiacao = contexts => contexts.dataFimResolverProblemasEmpatesPremiacao;

export const isPeriodoInscricoes = contexts => contexts.periodoInscricoes

export const isPeriodoInscricoesPorModalidade = (contexts, modalidade = "MODALIDADE_UM") => modalidade === "MODALIDADE_UM" && contexts.periodoInscricoesPorModalidade;

export const isPeriodoInscricoesModalidadeUm = (contexts) => contexts.isPeriodoInscricoesModalidadeUm;

export const isPeriodoInscricoesParaEscolas = contexts => contexts.periodoInscricoesParaEscolas;

export const isPeriodoInscricoesModalidadeUmParaEscolas = (contexts) => contexts.periodoInscricoesModalidadeUmParaEscolas;

export const isPeriodoPagamento = contexts => contexts.periodoPagamento;

export const isPeriodoRegistroParticipacaoCadastroAlunos = contexts => contexts.periodoRegistroParticipacaoCadastroAlunos;

export const isAfterPeriodoRegistroParticipacaoCadastroAlunos = contexts => contexts.depoisPeriodoRegistroParticipacaoCadastroAlunos;

export const isAfterInicioPeriodoRegistroParticipacaoCadastroAlunos = contexts => contexts.depoisInicioPeriodoRegistroParticipacaoCadastroAlunos;

export const isBeforeDataInicioPagamento = contexts => contexts.antesDataInicioPagamento;

export const isAfterDataFimInscricaoEDataFimPagamento = contexts => contexts.depoisDataFimInscricaoEDataFimPagamento;

export const isAfterDataProvaFase1 = contexts => contexts.depoisDataProvaFase1;

export const isAfterDataProvaFase2 = contexts => contexts.depoisDataProvaFase2;

export const isPeriodoEnvioObjetosPostais2Fase = contexts => contexts.periodoEnvioObjetosPostais2Fase;

export const getInicioEnvioObjetosPostais2Fase = contexts => contexts.inicioEnvioObjetosPostais2Fase;

export const getTerminoEnvioObjetosPostais2Fase = contexts => contexts.terminoEnvioObjetosPostais2Fase;

export const isPeriodoRastreamentoObjetosPostais2Fase = contexts => contexts.periodoRastreamentoObjetosPostais2Fase;

export const getInicioRastreamentoObjetosPostais2Fase = contexts => contexts.inicioRastreamentoObjetosPostais2Fase;

export const getTerminoRastreamentoObjetosPostais2Fase = contexts => contexts.terminoRastreamentoObjetosPostais2Fase;

export const isPermiteCadastroAlunosProvasEspeciais = contexts => contexts.permiteCadastroAlunosProvasEspeciais;

export const isPeriodoInserirNotaFase2 = contexts => contexts.periodoInserirNotaFase2;

export const isAfterInicioPeriodoInserirNotaFase2 = contexts => contexts.depoisInicioPeriodoInserirNotaFase2;

export const isAfterFimPeriodoInserirNotaFase2 = contexts => contexts.depoisFimPeriodoInserirNotaFase2;

export const getFimPeriodoInserirNotaFase2 = contexts => contexts.fimPeriodoInserirNotaFase2;

export const isPeriodoResolverProblemasEmpatesPremiacao = contexts => contexts.periodoResolverProblemasEmpatesPremiacao;

export const isHabilitadoUploadTermoAutorizacao = contexts => contexts.habilitadoUploadTermoAutorizacao;

export const isAfterInicioConsumoServicosImpressaoGrafica = contexts => contexts.depoisInicioConsumoServicosImpressaoGrafica;

export const isBeforeFimCentralResetarPremiacao = contexts => contexts.depoisFimCentralResetarPremiacao;

export const isAbertaDataAlternativaPremiacao = (contexts, dataAlternativaPremiacao) => {
    if (dataAlternativaPremiacao) {
        const dataAlternativa = parseDate(dataAlternativaPremiacao);
        dataAlternativa.setHours(23, 59, 59, 999);

        return dataAlternativa >= parseDateTime(contexts.dataHoraServidor);
    }

    return false;
}     

export const getDataAlternativaPremiacao = (dataAlternativaPremiacao) => dataAlternativaPremiacao ? toDate(dataAlternativaPremiacao) : null;